import { Step } from "./SpcSidebarFormNavigation";

export function generateStepArray(steps: Step[]): Array<{ slug: string, stepNumber: number }> {
  let stepArray: Array<{ slug: string, stepNumber: number }> = [];
  let stepCount = 0;

  steps.forEach((step, index) => {
    stepCount++;
    stepArray.push({ slug: step.slug, stepNumber: stepCount });
    step.subSteps.forEach(subStep => {
      stepCount++;
      stepArray.push({ slug: step.slug + '/' + subStep.slug, stepNumber: stepCount });
    });
  });

  return stepArray;
}

export function getStepNumberBySlug(slug: any, steps: Array<{ slug: string, stepNumber: number }>): number {
  const step = steps.find(step => step.slug === slug);
  return step ? step.stepNumber : 0;
}